<div style="margin-bottom: 5px">
  <div *ngFor="let row of section.rows; trackBy:trackByIndex">
    <div *ngIf="isRowVisible(row)" class="flex-grid flex-albatross overview__section-row">
      <pqm-field *ngFor="let field of row.items; trackBy:trackByName" [field]="field" [isEditing]="pqmParams.editing"
                 attr.test-id="{{field.name}}" (valueChanged)="onFieldChanged($event)"></pqm-field>
    </div>
  </div>
</div>
